import { useApolloClient, useFragment } from "@apollo/client"

import { ProductPositionTypename } from "shared/types/Project"

import {
  ProductPositionFragment,
  ProductPositionFragmentDoc
} from "entities/product-positions/graphql/fragments.generated"

export function useProductPositionFragment(id: string | null | undefined) {
  const { cache } = useApolloClient()

  const { complete, data } = useFragment<ProductPositionFragment>({
    fragment: ProductPositionFragmentDoc,
    fragmentName: "ProductPosition",
    from: cache.identify({ id, __typename: ProductPositionTypename })
      ? { id, __typename: ProductPositionTypename }
      : null
  })

  return complete ? data : undefined
}
